import type { IAttributes, IDirective } from "angular";
import { module } from "angular";

import { includes } from "lodash";

export default class UniqueValidationDirective implements IDirective {
    public priority = 1000;

    public restrict = "AE";

    public require = ["^form", "?ngModel"];

    public link = (
        scope: any,
        instanceElement: JQuery,
        instanceAttributes: IAttributes,
        [formController, ngModelController]: any[],
    ) => {
        if (!formController || !ngModelController) {
            return;
        }

        const form = instanceElement.parents("form");

        ngModelController.$validators.unique = (modelValue: any, viewValue: any) => {
            const uniqueGroupElements = form
                .find(`[unique-group-name="${scope.uniqueGroupName}"]`)
                .filter((index, element) => element.id !== instanceElement[0].id);

            const uniqueGroupValues = uniqueGroupElements.map((index, element) => (element as HTMLInputElement).value);

            const uniqueGroupNames = uniqueGroupElements
                .map((index, element) => (element as HTMLInputElement).name)
                .toArray();

            uniqueGroupNames.forEach((name) => {
                const otherInputController = formController[name as any as string];

                if (otherInputController && !(viewValue === otherInputController.$viewValue)) {
                    otherInputController.$setValidity("unique", true);
                }
            });

            return !includes(uniqueGroupValues, viewValue);
        };
    };
}

module("mmGui").directive("irUnique", () => new UniqueValidationDirective());
